var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.914062,
    width: 16,
    height: 16,
    rx: 3,
    fill: "black",
    fillOpacity: 0.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91439 8.33203C9.09848 8.33203 9.24772 8.18279 9.24772 7.9987C9.24772 7.8146 9.09848 7.66536 8.91439 7.66536C8.73029 7.66536 8.58105 7.8146 8.58105 7.9987C8.58105 8.18279 8.73029 8.33203 8.91439 8.33203Z",
    stroke: "#E9E9E9",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91439 5.9987C9.09848 5.9987 9.24772 5.84946 9.24772 5.66536C9.24772 5.48127 9.09848 5.33203 8.91439 5.33203C8.73029 5.33203 8.58105 5.48127 8.58105 5.66536C8.58105 5.84946 8.73029 5.9987 8.91439 5.9987Z",
    stroke: "#E9E9E9",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91439 10.6654C9.09848 10.6654 9.24772 10.5161 9.24772 10.332C9.24772 10.1479 9.09848 9.9987 8.91439 9.9987C8.73029 9.9987 8.58105 10.1479 8.58105 10.332C8.58105 10.5161 8.73029 10.6654 8.91439 10.6654Z",
    stroke: "#E9E9E9",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionIcon);
export default __webpack_public_path__ + "static/media/optionIcon.6a8df9693624f93dd871eeb80f2efbff.svg";
export { ForwardRef as ReactComponent };